import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { MapPin, Users, Award } from 'lucide-react';

export default function LocalContractor() {
  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="bg-white py-12 sm:py-16 md:py-24">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-4 sm:space-y-6 order-2 lg:order-1"
          >
            <div className="relative aspect-square rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e?auto=format&fit=crop&w=800&q=80" 
                alt="Elite Roofing Professional Team"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/80 to-transparent flex items-end">
                <div className="p-6 sm:p-8 text-white">
                  <p className="text-2xl sm:text-3xl font-bold mb-2">30+ Years</p>
                  <p className="text-base sm:text-lg">Combined Experience</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-4 sm:space-y-6 order-1 lg:order-2"
          >
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-3 sm:mb-4">
                Local Roofing Contractors
              </h2>
              <p className="text-xl sm:text-2xl text-[hsl(var(--primary))] font-bold mb-4 sm:mb-6">
                Family Owned & Operated
              </p>
            </div>

            <div className="space-y-3 sm:space-y-4 text-slate-600 text-sm sm:text-base leading-relaxed">
              <p className="text-base sm:text-lg">
                <strong className="text-slate-900">Elite Roofing is there when you need us!</strong>
              </p>
              
              <p>
                We can handle any roof repair or roof replacement project throughout Central Florida. Quality, integrity, and good old-fashioned customer service are the pillars we thrive on. 
              </p>
              
              <p>
                There isn't another roofing contractor in Central Florida that can compete with our combination of expertise, responsiveness, and commitment to customer satisfaction!
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 sm:gap-6 py-4 sm:py-6">
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e9f2fb] text-[hsl(var(--primary))] mb-2 sm:mb-3">
                  <MapPin className="h-6 w-6 sm:h-8 sm:w-8" />
                </div>
                <p className="font-bold text-slate-900 text-xs sm:text-base">Central Florida</p>
                <p className="text-xs text-slate-600">Service Area</p>
              </div>
              
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e9f2fb] text-[hsl(var(--primary))] mb-2 sm:mb-3">
                  <Users className="h-6 w-6 sm:h-8 sm:w-8" />
                </div>
                <p className="font-bold text-slate-900 text-xs sm:text-base">Family Owned</p>
                <p className="text-xs text-slate-600">Since Day One</p>
              </div>
              
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#e9f2fb] text-[hsl(var(--primary))] mb-2 sm:mb-3">
                  <Award className="h-6 w-6 sm:h-8 sm:w-8" />
                </div>
                <p className="font-bold text-slate-900 text-xs sm:text-base">Licensed</p>
                <p className="text-xs text-slate-600">& Insured</p>
              </div>
            </div>

            <div className="pt-2 sm:pt-4">
              <Button 
                onClick={scrollToForm}
                className="h-12 sm:h-14 px-6 sm:px-8 bg-[hsl(var(--accent))] text-white hover:bg-[#a01830] transition-all shadow-lg text-base sm:text-lg font-semibold w-full sm:w-auto"
              >
                View Service Areas
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}